var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroomWhiteTransparent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.999,
    height: 36.001,
    viewBox: "0 0 41.999 36.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "classroom",
    transform: "translate(-3 -5.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M-12122-8866h-34a4.006,4.006,0,0,1-4-4v-28a4.006,4.006,0,0,1,4-4h34a4,4,0,0,1,4,4v28A4,4,0,0,1-12122-8866Zm-34-32v28h34v-28Z",
    transform: "translate(12163 8908)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M24,17a3,3,0,1,0,3,3A3,3,0,0,0,24,17Z",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M16,21a2,2,0,1,0,2,2A2,2,0,0,0,16,21Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M7,10H41v1H7Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M36,38H28l4,4h8Z",
    fill: "#4378ee",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M32,21a2,2,0,1,0,2,2A2,2,0,0,0,32,21Zm5,7.688a1.746,1.746,0,0,0-.468-1.2A6.169,6.169,0,0,0,32,26a6.169,6.169,0,0,0-4.532,1.489,1.744,1.744,0,0,0-.468,1.2V30H37Zm-16,0a1.746,1.746,0,0,0-.468-1.2A6.169,6.169,0,0,0,16,26a6.169,6.169,0,0,0-4.532,1.489,1.744,1.744,0,0,0-.468,1.2V30H21Z",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M30,27.742a2.094,2.094,0,0,0-.562-1.438,7.571,7.571,0,0,0-10.876,0A2.1,2.1,0,0,0,18,27.742V30H30Z",
    fill: "#fff",
    opacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomWhiteTransparent);
export default __webpack_public_path__ + "static/media/classroom_white-transparent.868dbb974afaaa0aa9db864e702beca7.svg";
export { ForwardRef as ReactComponent };